import { render, staticRenderFns } from "./BotFlow.vue?vue&type=template&id=341964fd&scoped=true"
import script from "./BotFlow.vue?vue&type=script&lang=js"
export * from "./BotFlow.vue?vue&type=script&lang=js"
import style0 from "./BotFlow.vue?vue&type=style&index=0&id=341964fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341964fd",
  null
  
)

export default component.exports